// ── ChecklistMappingPage ──
import { useState, useEffect } from "react";
import { B } from "../../../shared/theme";
import { Card, ErrorMsg, FSelect, SectionHeader, Spinner, Td, TdNum, Th } from "../../../shared/ui";
import { useApp } from "../../../shared/appContext";

export const ChecklistMappingPage = () => {
    const { api } = useApp();
  const TERM_TYPES = ["New Loan","Amendment with Funding","Amendment without Funding","Discretionary Amendment","Loan Renewal"];
  const [termType,setTermType]=useState(TERM_TYPES[0]);
  const [rows,setRows]=useState([]); const [loading,setLoading]=useState(true); const [err,setErr]=useState(null);
  const [savingId,setSavingId]=useState(null);

  const load=(tt)=>{setLoading(true);api.get("getChecklistMapping?term_type="+encodeURIComponent(tt)).then(d=>{setRows(d);setLoading(false);}).catch(e=>{setErr(e.message);setLoading(false);});};
  useEffect(()=>{load(termType);},[termType]);

  const toggle = async (row) => {
    const next = !row.mapped;
    setSavingId(row.id);
    setRows(rs=>rs.map(r=>r.id===row.id?{...r,mapped:next}:r)); // optimistic
    try {
      await api.post("saveChecklistMapping",{ term_type:termType, checklistcatalogid:row.id, mapped:next });
    } catch(e) {
      setRows(rs=>rs.map(r=>r.id===row.id?{...r,mapped:!next}:r)); // revert on failure
    } finally { setSavingId(null); }
  };

  const mappedCount = rows.filter(r=>r.mapped).length;

  return <>
    <SectionHeader />
    <Card style={{ marginBottom:16, padding:16 }}>
      <div style={{ display:"flex", alignItems:"center", gap:16, flexWrap:"wrap" }}>
        <div style={{ fontSize:13, fontWeight:600, color:B.cyanDark }}>Term Type</div>
        <FSelect value={termType} onChange={e=>setTermType(typeof e==="object"?e.target.value:e)} options={TERM_TYPES} />
        <div style={{ fontSize:12, color:"var(--color-text-secondary)" }}>
          {mappedCount} item{mappedCount!==1?"s":""} generated for this term type
        </div>
      </div>
      <div style={{ fontSize:12, color:"var(--color-text-secondary)", marginTop:8 }}>
        Checked items are created when a checklist is generated for a <b>{termType}</b> term.
      </div>
    </Card>

    {loading ? <Spinner /> : err ? <ErrorMsg msg={err} onRetry={()=>load(termType)} /> :
    <Card style={{ overflowX:"auto" }}>
      <table style={{ width:"100%",borderCollapse:"collapse", whiteSpace:"nowrap" }}>
        <thead><tr>
          <Th>Include</Th><Th>Order</Th><Th>Category</Th><Th>Name</Th>
        </tr></thead>
        <tbody>{rows.map(r=>(
          <tr key={r.id} style={{ cursor:"pointer" }} onClick={()=>toggle(r)} onMouseEnter={e=>e.currentTarget.style.background="var(--color-background-secondary)"} onMouseLeave={e=>e.currentTarget.style.background=""}>
            <Td onClick={e=>e.stopPropagation()}>
              <input type="checkbox" checked={!!r.mapped} disabled={savingId===r.id} onChange={()=>toggle(r)} style={{ cursor:"pointer" }} />
            </Td>
            <TdNum>{r.order??"—"}</TdNum>
            <Td>{r.category||"—"}</Td>
            <Td style={{ fontWeight: r.mapped?600:400 }}>{r.name||"—"}</Td>
          </tr>
        ))}</tbody>
      </table>
    </Card>}
  </>;
};
